import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import EventosView from '../views/EventosView.vue'
import TecnologiaView from '../views/TecnologiaView.vue'
import NoticiasView from '../views/NoticiasView.vue'
import ArticleView from '../views/ArticleView.vue'
import SearchView from '../views/SearchView.vue'
import ContatoView from '../views/ContatoView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/eventos',
    name: 'eventos',
    component: EventosView
  },
  {
    path: '/tecnologia',
    name: 'tecnologia',
    component: TecnologiaView
  },
  {
    path: '/noticias',
    name: 'noticias',
    component: NoticiasView
  },
  {
    path: '/buscar',
    name: 'search',
    component: SearchView
  },
  {
    path: '/noticia/:id',
    name: 'article',
    component: ArticleView
  },
  {
    path: '/contato',
    name: 'contato',
    component: ContatoView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
